import React from 'react'
import PropTypes from 'prop-types'
import EditAssignedModal from './EditAssignedModal'
import UpdateOrderForm from '../../../../components/UpdateOrderForm'

const EditAssignedForm = ({ movementNumber, tractor, open, onClose, onSubmit, loadUpdate }) => {
  return (
    <EditAssignedModal
      open={open}
      onClose={onClose}
    >
      <UpdateOrderForm
        movementNumber={movementNumber}
        tractor={tractor}
        onSubmit={onSubmit}
        loadUpdate={loadUpdate}
      />
    </EditAssignedModal>
  )
}

UpdateOrderForm.defaultProps = {
  tractor: {},
  movementNumber: ''
}

EditAssignedForm.propTypes = {
  movementNumber: PropTypes.string,
  tractor: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loadUpdate: PropTypes.bool.isRequired
}

export default EditAssignedForm
